import { Component } from '@angular/core';

import { SuburbCatalogueService } from '../workspace/catalogue.service';
import { MapToolsService } from '../workspace/map-tools.service';
import { WorkspaceStateService } from '../workspace/workspace-state.service';

/** Find a suburb in the loaded state by name (#256); a result opens its panel. */
@Component({
  selector: 'section[app-suburb-search]',
  templateUrl: './suburb-search.component.html',
  styleUrls: ['./suburb-search.component.scss'],
})
export class SuburbSearchComponent {
  constructor(
    public state: WorkspaceStateService,
    public catalogue: SuburbCatalogueService,
    public mapTools: MapToolsService
  ) {}
}
